<template>
  <section class="container diff">
    <h2>{{ diff.title }}</h2>
    <p v-html="diff.description"></p>
    <swiper
        :navigation="true"
        :modules="modules"
        :slides-per-view="swiperOptions.slidesPerView"
        :space-between="swiperOptions.spaceBetween"
        :breakpoints="swiperOptions.breakpoints"
    >
      <swiper-slide v-for="article in diff.articles" :key="article.id"><DiffCard :article="article" class="col-3 w-100" /></swiper-slide>
    </swiper>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper";
import DiffCard from "@/components/common/DiffCard";

export default {
  components: {
    DiffCard,
    Swiper,
    SwiperSlide
  },
  props: {
    diff: {
      title: String,
      description: HTMLElement,
      articles: Array
    }
  },
  setup(){
    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        580: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 4
        },
      },
    }

    return {
      modules: [Navigation],
      swiperOptions
    };
  },
}
</script>
